/**
 * "De aankondigingen zijn gewijzigd" (specs/20261016-taal-bewonersapp, T037c).
 *
 * De API stuurt `announcements_changed` na elke schrijfactie in het portaal. De
 * commandohandler draait op moduleniveau, buiten React; de schermen die aankondigingen
 * tonen luisteren hier en halen hun lijst opnieuw op. Een oudere app kent het commando
 * niet en ziet de wijziging bij de volgende ophaalbeurt.
 */
const listeners = new Set<() => void>();

export function emitAnnouncementsChanged(): void {
  listeners.forEach((l) => {
    try {
      l();
    } catch {
      /* één luisteraar mag de rest niet slopen */
    }
  });
}

export function onAnnouncementsChanged(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
